module.exports = __webpack_public_path__ + "static/img/me2.da2315ff.png";